var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenrouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Logo",
    className: "Navbar_logo__gEyoC",
    height: "100%",
    viewBox: "0 0 512 512",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 248.945C18 248.945 76 236 106 219C136 202 136 202 198 158C276.497 102.293 332 120.945 423 120.945",
    strokeWidth: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 121.5L357.25 210.268L357.25 32.7324L511 121.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 249C15 249 73 261.945 103 278.945C133 295.945 133 295.945 195 339.945C273.497 395.652 329 377 420 377",
    strokeWidth: 90
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 376.445L354.25 287.678L354.25 465.213L508 376.445Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_3"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 512,
    width: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenrouter);
export default __webpack_public_path__ + "static/media/openrouter.253830fc237ced01b226853f51c06011.svg";
export { ForwardRef as ReactComponent };